module.exports = __webpack_public_path__ + "img/DATA.2c9b0241.svg";